import { SingleUser } from '../api/types';
import moment from 'moment';
import { User } from './User';

export interface ChatMessageInterface {
  id: number;
  message: string;
  sendBy: SingleUser;
  timestamp: Date|string;
  read: boolean;
}

export class ChatMessage implements ChatMessageInterface {
  id: number;
  message: string;
  sendByName: string;
  sendBy: User;
  timestamp: Date;
  read: boolean;
  seen = true;

  constructor({ id, message, sendBy, timestamp, read }: ChatMessageInterface) {
    this.id = id;
    this.message = message;
    this.sendByName = sendBy.name;
    this.sendBy = new User(sendBy);
    this.timestamp = moment(timestamp).toDate();
    this.read = read;
  }

  static fromResponse(response: ChatMessageInterface[]): ChatMessage[] {
    return response
      .map((message) => new ChatMessage(message))
      .sort((a: ChatMessage, b: ChatMessage) => a.timestamp.getTime() - b.timestamp.getTime());
  }
}
